import React, { useState } from "react";

const BrandType = ({ initValue, onChange }) => {
  const [ brandTypeVal, setBrandTypeVal ] = useState(initValue || '');

  const handleOnChange = (event) => {
    setBrandTypeVal(event.target.value);
    onChange(event.target.value);
  };

  return (
    <div className="form_section">
      <div className="form_grid">
        <div className="form_grid-item -width-full">
          <div className="form_section-title-item">
            <h3>Which word best describes the brand offerings?</h3>
          </div>

          <div className="form_section-tabs">
            <div className="radio-tabs -borderer -gray-bg">
              <label id="label-product" className="radio-tabs_item">
                <input
                  id="project_brand_type_product"
                  type="radio"
                  checked={ brandTypeVal === "product" }
                  value="product"
                  onChange={ handleOnChange }
                />
                <div className="radio-tabs_label">Product</div>
              </label>
              <label id="label-service" className="radio-tabs_item">
                <input
                  id="project_brand_type_service"
                  type="radio"
                  checked={ brandTypeVal === "service" }
                  value="service"
                  onChange={ handleOnChange }
                />
                <div className="radio-tabs_label">Service</div>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrandType;
